import type { Product } from 'reactApp/types/Billing';
import { getMonthProductPrice } from 'reactApp/utils/priceHelpers';

export const economy = (monthProduct: Product, yearProduct: Product) => {
    const discountPeriodCount = monthProduct.discountPeriodCount || 0;
    const monthProductPrice = getMonthProductPrice(monthProduct);
    const yearProductPrice = yearProduct.discountPrice || yearProduct.price || 0;

    if (!yearProduct) {
        return;
    }

    return yearProductPrice
        ? discountPeriodCount * monthProductPrice +
              (12 - discountPeriodCount) * getMonthProductPrice(monthProduct, false) -
              yearProductPrice
        : 0;
};
